<script lang="ts">
	import { run } from "svelte/legacy"

	import Header from "../../reusable/Header.svelte"

	import { FileSystemMedia } from "../../../modules/FileSystems"
	import { UserStore } from "../../../stores/UserStore"

	import UrlBar from "./UrlBar.svelte"

	import { Folder } from "luxedo-data/src/entries/Folder"
	import Tile from "../../reusable/file-system/Tile.svelte"
	import { DataHandlerFolderAdmin, DataHandlerMediaAdmin, type Media, type User } from "luxedo-data"
	import { closeOverlay, openOverlay } from "overlay"
	import NewMediaForm from "./NewMediaForm.svelte"
	import { onMount } from "svelte"
	import LoadingPage from "../../reusable/loaders/LoadingPage.svelte"

	let { params } = $props()

	let user: User
	let publicMediaRootID: number = $state(15)

	let activeDirectory: Folder
	let media: Array<Media | Folder> = $state([])
	let path: Array<{ id: number; name: string }> = $state()

	let isUploading: boolean = $state(false)
	let isLoading: boolean = $state(true)

	let loadingPromise: Promise<any> = pullFoldersAndMedia()

	UserStore.subscribe((currUser) => {
		user = currUser
		console.log("USER UPDATE", user)
		if (user) initUserMedia(user)
	})

	async function initUserMedia(user: User) {
		if (loadingPromise) await loadingPromise

		publicMediaRootID = user.directories.public[0]
		if (!params.id) updateActiveDirectory(publicMediaRootID)
	}

	function updateActiveDirectory(newDirectory: number) {
		activeDirectory = FileSystemMedia.useDirectory(newDirectory, (directoryMedia) => {
			media = directoryMedia
		})

		console.log("updated", activeDirectory)

		path = FileSystemMedia.getFolderPath(activeDirectory, true)
	}

	async function postSubmit() {
		isUploading = false
	}

	function openUploadingOverlay() {
		openOverlay(NewMediaForm, {
			heading: "New Media or Folder",
			classHeading: "align-left",
			beforeClose: postSubmit,
			props: {
				activeFolder: activeDirectory,
				postSubmit,
			},
		})
	}

	async function pullFoldersAndMedia() {
		const promises = []
		promises.push(DataHandlerMediaAdmin.pull())
		promises.push(DataHandlerFolderAdmin.pull())
		await Promise.all(promises)
		isLoading = false
	}

	run(() => {
		isUploading && openUploadingOverlay()
	})

	run(() => {
		!isUploading && closeOverlay()
	})
</script>

{#if isLoading}
	<LoadingPage />
{:else}
	<Header heading="Media Manager" />
	{#if path}
		<div class="manager-container">
			<UrlBar
				{path}
				root={{ id: publicMediaRootID, name: "Public Media" }}
				{updateActiveDirectory}
			/>

			<div class="media-list">
				{#each media as m}
					<Tile
						file={m}
						onSelect={() => {
							if (m instanceof Folder) updateActiveDirectory(m.id)
						}}
					/>
				{/each}
			</div>
			<button id="upload-btn" onclick={() => (isUploading = true)} title="New Folder/Media"
				>Create New</button
			>
		</div>
	{/if}
{/if}

<style>
	.manager-container {
		background-color: var(--color-bg);
		width: 80vw;
		margin: 5vh 10vw;
		padding: 1rem 2rem 0.5rem 2rem;
		height: calc(90vh - var(--header-height));
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		border-radius: var(--br);
	}

	.media-list {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-content: flex-start;
		flex-wrap: wrap;
		background-color: var(--color-bg-dark);
		border-radius: var(--br);
		width: 100%;
		margin-top: 1rem;
		padding: 0.25rem;
		height: 100%;
		overflow-y: scroll;
	}

	#upload-btn {
		margin-top: 0.5rem;
	}
</style>
